const actions = {
  SAVE_RESOURCE: 'general/SAVE_RESOURCE',
  SET_STATE: 'general/SET_STATE',
  CHANGE_LEDGER_MODAL_STATUS: 'general/CHANGE_LEDGER_MODAL_STATUS',
}

export default actions
